import axios from '../../../axios';
import IClientSettings from '../types/IClientSettings';
import IOrganizationalIds from '../types/IOrganizationalIds';
import IOrganizationalUnit from '../types/IOrganizationalUnit';
import IOrganizationalUnitClientManagers from '../types/IOrganizationalUnitClientManagers';
import IOrganizationalUnitClients from '../types/IOrganizationalUnitClients';
import IOrganizationalUnitManagers from '../types/IOrganizationalUnitManagers';
import IOrganizationalUnitTeams from '../types/IOrganizationalUnitTeams';
import IViewers from '../types/IViewers';

const url = '/api/';

export const getAllOrganizationalUnitSettings = () =>
  axios.get(`${url}get-organizational-units-settings`);

export const getAllOrganizationalUnits = (scope: string) =>
  axios.post(`${url}get-organizational-units-settings/${scope}`);

export const createNewOrganizationalUnitSettings = (organizationalUnitEntity: IClientSettings) =>
  axios.post(`${url}create-organizational-unit-settings`, organizationalUnitEntity);

export const updateOrganizationalUnitSettings = (organizationalUnitEntity: IOrganizationalUnit) =>
  axios.put(`${url}update-organizational-unit-settings`, organizationalUnitEntity);

export const createOrganizationalUnitTeams = (
  organizationalUnitTeamsEntity: IOrganizationalUnitTeams[]
) => axios.post(`${url}create-organizational-unit-teams`, organizationalUnitTeamsEntity);

export const selectedOrganizationalUnitTeams = (id: string) =>
  axios.get(`${url}get-organizational-units-teams/` + id);

export const createOrganizationalUnitManagers = (
  organizationalUnitManagersEntity: IOrganizationalUnitManagers[]
) => axios.post(`${url}create-organizational-unit-managers`, organizationalUnitManagersEntity);

export const selectedOrganizationalUnitManagers = (id: string) =>
  axios.get(`${url}get-organizational-units-managers/` + id);

export const deleteOUTeamMember = (id: string) => axios.delete(`${url}delete/${id}`);

export const deleteOUManagerMember = (id: string) =>
  axios.delete(`${url}delete-account-manager/${id}`);

export const getTeamsCount = (organizationalIds: IOrganizationalIds) =>
  axios.post(`${url}get-organizational-units-teams/teams-count`, organizationalIds);
export const getAccountManagerCount = (organizationalIds: IOrganizationalIds) =>
  axios.post(`${url}get-organizational-units-managers/account-managers-count`, organizationalIds);

export const createOrganizationalUnitClients = (
  organizationalUnitClientsEntity: IOrganizationalUnitClients[]
) => axios.post(`${url}organizational-unit-clients`, organizationalUnitClientsEntity);
export const getSelectedOUClients = (id: string) =>
  axios.get(`${url}organizational-unit-clients/${id}`);
export const deleteOUClient = (id: string) =>
  axios.delete(`${url}organizational-unit-clients/${id}`);
export const createOrganizationalUnitClientManagers = (
  organizationalUnitClientManagersEntity: IOrganizationalUnitClientManagers[]
) =>
  axios.post(`${url}organizational-unit-client-managers`, organizationalUnitClientManagersEntity);
export const selectedOrganizationalUnitClientManagers = (id: string) =>
  axios.get(`${url}organizational-unit-client-managers/` + id);
export const deleteOUClientManagerMember = (id: string) =>
  axios.delete(`${url}organizational-unit-client-managers/${id}`);

export const getClientsCount = (organizationalIds: IOrganizationalIds) =>
  axios.post(`${url}organizational-unit-clients/clients-count`, organizationalIds);

export const getClientContactsCount = (organizationalIds: IOrganizationalIds) =>
  axios.post(`${url}organizational-unit-client-managers/contacts-count`, organizationalIds);

export const addViewersToUnit = (payload: IViewers) =>
  axios.post(`${url}organizational-unit-clients/add-viewers`, payload);

export const deleteViewersFromUnit = (payload: IViewers) =>
  axios.post(`${url}organizational-unit-clients/delete-viewers`, payload);

export const addViewersToTeamsUnit = (payload: IViewers) =>
  axios.post(`${url}organizational-unit-teams/add-viewers`, payload);

export const deleteViewersFromTeamsUnit = (payload: IViewers) =>
  axios.post(`${url}organizational-unit-teams/delete-viewers`, payload);

export const addViewersToClientContactsUnit = (payload: IViewers) =>
  axios.post(`${url}organizational-unit-client-managers/add-viewers`, payload);

export const deleteViewersFromClientContactsUnit = (payload: IViewers) =>
  axios.post(`${url}organizational-unit-client-managers/delete-viewers`, payload);
